function uibRun($document, runtimeUibModal) {
    'ngInject';

    const init = function () {
        setUibModalDefaults();
    };

    const setUibModalDefaults = function () {
        runtimeUibModal.options.appendTo = angular.element($document[0].getElementById('bb'));
    };

    init();
}

export default  uibRun;



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-uib/main.run.js